import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import API from '../api';

// ── 스토리지 백업 권장 안내 ──────────────────────────────────────────────
// "1개월에 한번씩 스토리지 백업을 권장하며 최초 백업후 1개월이 지난 시점에 최고관리자,
// 전산담당자, 대표이사에게 안내문구를 띄워줌" 요청. HrInfoRequestAlert.js와 동일하게
// 실시간 소켓 대신(스토리지 백업은 매 순간 상태가 바뀌는 게 아니라 "한 달 지났는지"만 확인하면
// 되므로 별도 스케줄러/소켓 없이도 충분하다) 화면 진입/마운트 시 한 번 REST로 확인하는
// 방식만 사용한다 — GET /api/storage-backup/reminder가 로그인한 사용자가 알림 대상인지와
// 기한이 지났는지를 서버에서 판단해서 돌려준다.
export default function StorageBackupReminderAlert() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null); // { show, reason, lastBackupAt, daysSince }
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!user) return;
    API.get('/storage-backup/reminder')
      .then(res => { if (res.data?.show && !document.fullscreenElement) setInfo(res.data); })
      .catch(() => {});
  }, [user]);

  if (!info || dismissed) return null;

  const goBackup = () => {
    setDismissed(true);
    navigate('/storage', { state: { openBackup: true } });
  };

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:3000,
      display:'flex', alignItems:'center', justifyContent:'center' }}
      onClick={() => setDismissed(true)}>
      <div style={{ background:'#fff', borderRadius:14, width:400, maxWidth:'90vw', padding:'26px 24px 22px' }}
        onClick={e => e.stopPropagation()}>
        <div style={{ fontSize:12.5, fontWeight:700, color:'#b45309', marginBottom:8 }}>
          🗄️ 스토리지 백업 안내 ({info.reason})
        </div>
        <div style={{ fontSize:16.5, fontWeight:700, color:'#1a1a1a', marginBottom:8 }}>
          스토리지를 백업한 지 {info.daysSince ?? '30'}일이 지났습니다
        </div>
        <div style={{ fontSize:13, color:'#666', marginBottom:4 }}>
          마지막 백업: {info.lastBackupAt || '-'}
        </div>
        <div style={{ fontSize:12, color:'#999', marginTop:6, lineHeight:1.5 }}>
          한 달에 한 번씩 서버 컴퓨터의 하드디스크/USB로 스토리지 전체를 백업하는 것을
          권장합니다. 스토리지 메뉴에서 "🗄️ 스토리지 백업" 버튼으로 바로 실행할 수 있습니다.
        </div>
        <div style={{ display:'flex', gap:8, marginTop:20 }}>
          <button onClick={goBackup}
            style={{ flex:1, padding:'11px', background:'#b45309', color:'#fff', border:'none',
              borderRadius:8, fontSize:13, fontWeight:700, cursor:'pointer' }}>
            지금 확인
          </button>
          <button onClick={() => setDismissed(true)}
            style={{ flex:1, padding:'11px', background:'#fff', color:'#555', border:'1px solid #ddd',
              borderRadius:8, fontSize:13, fontWeight:600, cursor:'pointer' }}>
            나중에
          </button>
        </div>
      </div>
    </div>
  );
}
